/*
 * Copyright (c) 2020. AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import { LanguageSelectorIcon } from "./LanguageSelectorIcon";
import { changeLanguage, getAvailableLanguageMap, i18nInstance } from "../../../utils/i18n/i18n";
import "./LanguageSelector.scss";
import Select from "../Select/Select";
import { SelectOption } from "../../../model/common";
import { isInLauncher, withLauncherWebviewClient } from "../../../utils/launcherWebviewClient";

const LanguageSelector = () => {
  const currentLanguage = i18nInstance.language;
  const languageMap = getAvailableLanguageMap();

  const getLanguageOptions = (): SelectOption[] => {
    return Object.keys(languageMap).map((languageCode) => ({
      label: languageMap[languageCode],
      value: languageCode,
    }));
  };

  const getCurrentLanguageOption = (lang: string): SelectOption | undefined => {
    return getLanguageOptions().find((option) => option.value === lang);
  };

  return (
    <div className="languangeSelector">
      <LanguageSelectorIcon className="languageIcon" />
      <Select
        options={getLanguageOptions()}
        onChange={(option: SelectOption) => {
          if (isInLauncher()) {
            withLauncherWebviewClient((client) => {
              client.changeLanguage(option.value);
            });
          } else {
            changeLanguage(option.value);
          }
          window.location.reload();
        }}
        defaultValue={getCurrentLanguageOption(currentLanguage)}
        menuPlacement="top" // SA-1007 restyling language selector
        isSearchable={false} // SA-1007 restyling language selector
      />
    </div>
  );
};

export default LanguageSelector;
